import { Box } from '@mui/material'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { GetVisitorReasonActions } from '../../../../../store/Employee/Visitors/Action';
import PreRegFormFlow from './PreRegFormFlow';
import { DateConvertInDbFormat } from '../../../Base/helper/baseFunctions';
import ArrowBackButton from '../../../Base/views/ArrowBackButton';
import { GetVMOrgTypeHelper } from '../../../VisitorSettings/helper/OrgType/OrgTypeHelper';
import { GetEmployeesAndExternalUsersHelper } from '../../../Employee/helper/EmployeeHelper';

const PreBooking = ({setMode, mode, currentEditData}) => {
  const initialValue = {
    visitors_mobile_no: "",
    visitors_name: "",
    employee_id: "",
    visitors_management_reasons_pk: "",
    id_proof: "", 
    vehicle_no: "",
    booking_date: DateConvertInDbFormat()
  };

  const dispatch = useDispatch();
  const [visitorRegData, setVisitorRegData] = useState(initialValue);
  const [isSingleOrg, setIsSingleOrg] = useState(true);
  const [employeesData, setEmployeesData] = useState({
      load: true,
      values: [],
    });
    const [visitorReasonData, setVisitorReasonData] = useState({
      load: true,
      values: [],
    });
    const [employeesOptions, setEmployeesOptions] = useState([]);
  
    const { visitor_reasons } = useSelector(
      (state) => state?.EmployeeReducer?.VisitorsReducer
    );
    const handleEmployees = () => {
      employeesOptions &&
        setEmployeesData({ load: false, values: employeesOptions });
    };
    const handleVisitorReasons = () => {
      visitor_reasons &&
        setVisitorReasonData({ load: false, values: visitor_reasons });
    };

    useEffect(() => {
      GetEmployeesAndExternalUsersHelper().then((res) => {
        if (res?.data?.statuscode === 200) {
          setEmployeesData({ load: false, values: res?.data?.data });
          setEmployeesOptions(res?.data?.data);
        } else {
          setEmployeesData({ load: false, values: [] });
        }
      })
      dispatch(GetVisitorReasonActions());
      GetVMOrgTypeHelper().then((res) => {
        if(res?.data?.statuscode === 200) {
          setIsSingleOrg(res?.data?.data?.[0]?.is_vm_org_type_single)
        }
      })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    useEffect(() => {
      if(currentEditData && mode === "edit") {
        setVisitorRegData({
          ...currentEditData,
          employee_id: {employee_id: currentEditData?.visited_employee_fk, name: currentEditData?.employee_name},
          visitors_management_reasons_pk: {visitors_management_reasons_pk: currentEditData?.visitor_reason_fk, reason: currentEditData?.reason},
        })
      }
      // eslint-disable-next-line
    },[])
  return (
    <Box height={"calc(100vh - 75px)"}>
      <Box elevation={0} sx={{ border: "2px solid #e0e0e0", mt: 2, pt: "65px", pb: "20px", borderRadius: 1, position: "relative" }}>
        <Box
          sx={{
            width: "1px",
            position: "absolute",
            left: "15px",
            top: "10px",
          }}
        >
          <ArrowBackButton onClick={() => setMode("grid")}/>
        </Box>
        <PreRegFormFlow
            employeesData={employeesData}
            handleEmployees={handleEmployees}
            handleVisitorReasons={handleVisitorReasons}
            visitorReasonData={visitorReasonData}
            visitorRegData={visitorRegData}
            setVisitorRegData={setVisitorRegData}
            initialValue={initialValue}
            setMode={setMode}
            isSingleOrg={isSingleOrg}
          />
      </Box>
    </Box>
  )
}

export default PreBooking